import { makeStyles } from "@material-ui/core/styles";
export const cardImageWidth = 300;
export const cardImageHeight = 190;
export const useStyles = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(2),
        overflow: 'hidden',
    },
    card: {
        display: 'flex',
    },
    cardMain: {
        padding: theme.spacing(1),
        flex: '1 0',
    },
    cardActions: {
        display: "flex",
        flexFlow: "column",
    },
    cardCollapse: {
        padding: theme.spacing(1),
    },
    img: {
        margin: theme.spacing(1),
        backgroundColor: '#ccc',
        borderRadius: theme.shape.borderRadius,
        overflow: "hidden",
        height: cardImageHeight,
        width: cardImageWidth,
        '& a': {
            display: 'block',
            width: '100%',
            height: '100%',
        }
    }
}));
